import React from "react";
import processIcon from "../image/process.png";
import playIcon from "../image/play.png";

const ProcessTableMobile = ({ videoProcesses, handlePlayClick }) => {
  return (
    <div className="mobile-play-table" style={{ paddingTop: '1px' }}>
      <table>
        <tbody>
          {videoProcesses.map((process, index) => (
            <React.Fragment key={index}>
              <tr>
                {/* Play Button First */}
                <td>
                  <button
                    className="play-button"
                    onClick={() =>
                      handlePlayClick(process, process.name === "Process" ? "pdf" : "video")
                    }
                  >
                    <img
                      src={process.name === "Process" ? processIcon : playIcon}
                      alt="Play"
                      className="play-icon"
                      style={{ width: "35px", height: "35px", borderRadius: "50%" }}
                    />
                  </button>
                </td>

                {/* Process Name (Left Aligned) */}
                <td className="process-name-mobile">
                <p className="process-text">{process.name.trim()}</p>
                </td>
              </tr>

              {/* Add spacing for 'Process' rows */}
              {process.name === "Process" && (
                <tr>
                  <td colSpan="2">&nbsp;</td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProcessTableMobile;
